<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
        :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <ViewDetails :object="object" type="SolicitudBaja" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
// import DataTableMain from '@/components/tables/DataTableMain'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'inventariable.solicitudes_baja.entry' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Fecha', value: 'ObjetDateDinamic', class: 'black--text', showItemColum: 'created_at' },
          { text: 'Departamento', value: 'departamento_baja.nombre', class: 'black--text' },
          { text: 'Num. de Bienes', value: 'NumBajas', class: 'black--text', align: 'center' },
          { text: 'Solicitante', value: 'solicitante.NombreCompleto', class: 'black--text' },
          { text: 'Depto. Tramitante', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Tipo de Bien', value: 'tipo_bien.nombre', class: 'black--text' },
          { text: 'Tipo de Bien', value: 'tipo_bien.nombre', class: 'black--text' },
          { text: 'Tipo Inventario', value: 'tipo_inventario.nombre', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'inventariable.solicitudes_baja.entry' },
          { title: 'Solicitud de Baja', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'inventario.bajas.rpt' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {}
  }),
  components: {
    DataTableMainServer,
    // DataTableMain,
    ViewDetails
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'GETExportPdftSerice', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('bajas.list')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('bajas.list')
      // this.pages = val
    },
    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosEquiposFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('bajas.list')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filtro',
        with: 850,
        title: 'Filtro de bajas',
        body: {
          objectMain: {},
          paramsDialog: {
            form: this.get_filter_bajas,
            message: 'Registro Agregado Correctamente'
          }
        }
      })
    },

    updateData ({ item }) {
      const estatusIds = [61, 56, 72, 73]
      // Verificar si el estatus_id está en el array
      if (estatusIds.includes(item.last_movement.estatus_id)) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El bien ya no se puede editar debido a su estatus actual.'
        })

        return
      }
      const BajasForm = JSON.parse(JSON.stringify(this.get_EditBajasForm))
      BajasForm.map(field => {
        if (field.field === 'TableDataServer') {
          field.data = { bajas: item.descripcion.bajas_ids }
        }
      })
      const data = {
        folio: item.folio,
        bajas: item.descripcion.bajas_ids
      }

      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '75%',
        title: 'Editar Solicitud',
        body: {
          objectMain: data,
          paramsDialog: {
            form: BajasForm,
            url: this.get_urls['bajas.update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    DownloadPdfData ({ item }) {
      this.GETExportPdftSerice({ url: this.get_urls['inventario.bajas.rpt'], replace: '{id}', params: item.id })
    },
    toUploadDoc (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'charge',
        form: 'process',
        with: '55%',
        title: 'Documento de Solicitud',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['bajas.execute'],
            urloption: this.get_urls['bajas.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          },
          method: 'form-data'
        }
      })
    },
    toFinish (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'finish',
        form: 'process',
        with: '55%',
        title: 'Dictamen de Bienes',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['bajas.execute'],
            urloption: this.get_urls['bajas.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          },
          method: 'form-data'
        }
      })
    },
    toAproved (item) {
      const Copyitem = JSON.parse(JSON.stringify(item))
      let transfer = []
      Copyitem.body.status_finish.formulario.fields.map(field => {
        if (field.field === 'TableDataServer') {
          transfer = item.item.bajas.map(tans => { return tans.id })
          field.data = { bajas: transfer }
        }
      })
      const data = {
        folio: item.folio,
        bajas: transfer
      }
      this.SHOW_DIALOG_MAIN({
        type: 'aproved',
        form: 'process',
        with: '50%',
        title: 'Bienes a Desincorporar',
        body: {
          objectMain: Copyitem,
          paramsDialog: {
            url: this.get_urls['bajas.execute'],
            urloption: this.get_urls['bajas.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data
          }
        }
      })
    },
    toApli (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'apli',
        form: 'process',
        with: '50%',
        title: 'Documento de confirmacion',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['bajas.execute'],
            urloption: this.get_urls['bajas.options'],
            message: 'tTransferencia correcta',
            returnObject: true,
            setmodel: false
          },
          method: 'form-data'
        }
      })
    }
  },

  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects', 'get_objectPagination', 'get_EditBajasForm', 'get_veryBajasForm', 'get_filter_bajas', 'get_sendDataView']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        if (rows.data.length > 0) {
          this.table.modelMain = []
          this.table.modelMain.push(rows.data[0])
        }
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
      this.table.header.loading = false
    },
    get_sendDataView ({ name, model }) {
      const data = JSON.parse(JSON.stringify(model))
      if (name === 'filtro') {
        this.SHOW_DIALOG_MAIN({
          type: 'create',
          form: 'process',
          with: '75%',
          title: 'Nuevo Solicitud De Baja',
          body: {
            objectMain: data,
            paramsDialog: {
              url: this.get_urls['bajas.execute'],
              urloption: this.get_urls['bajas.options'],
              message: 'Registro Agregado Correctamente',
              setmodel: true,
              setfilter: true,
              filter: model
            }
          }
        })
      }
      if (name === 'create') {
        this.refreshData({})
      }
    }
  }
}
</script>

<style>
</style>
